import { createContext } from 'react';


// This sets the global web application state when a user logs in or registers

// We will take that stored phoen number and use it to pull data from the database throughout the app

export const LoginContext = createContext();